import { Box } from '@chakra-ui/react';

import { useUserInfo } from 'Store/userInfo';
import Head from 'View/report-attendance-operator/section/head';
import Filter from 'View/report-attendance-operator/section/filter';
import Table from 'View/report-attendance-operator/section/table';
import ReportAttendanceOperatorProvider, { useReportAttendanceOperatorState } from 'View/report-attendance-operator/state';

import styles from './styles.module.css';
import { useParams } from 'react-router-dom';
import useGetOperatorPresence from 'Domain/report-attendance-operator/useGetOperatorPresence';

const ReportAttendanceOperator = () => {
  const { filterState } = useReportAttendanceOperatorState();
  const params = useParams();

  const { userId } = useUserInfo();
  const { id } = params;

  const operatorPresenceFilter = { ...filterState, id: id || userId };

  const { data, isFetching } = useGetOperatorPresence(operatorPresenceFilter);

  return (
    <Box className={styles['report-attendance__container']}>
      <Head data={data} isLoading={isFetching} />
      <Filter />
      <Table data={data} isFetching={isFetching} />
    </Box>
  );
};

const ReportAttendanceOperatorContainer = () => <ReportAttendanceOperatorProvider children={<ReportAttendanceOperator />} />;

export default ReportAttendanceOperatorContainer;
